import { useSelector } from "react-redux";
import ReportsSentRegulators from "./ReportsSentRegulators";
import SuspiciousReport from "./SuspiciousReport";
const FindSuspiciousReport = () => {
  const memberAnalyticsState = useSelector(state => state.memberAnalyticsFilter);
return (
      <>
       <section className="reports-sent-regulators w-12">
            <div className="grid mt-3">
                <div className="col-12 md:col-6">
                  <ReportsSentRegulators selectedDates={memberAnalyticsState.reportsDateRange}></ReportsSentRegulators>
                </div>
                <div className="col-12 md:col-6">
                   <SuspiciousReport></SuspiciousReport>
                </div>
            </div>
        </section>
      </>
       
    )
}
export default FindSuspiciousReport;